<template>
  <div class="unfolding-table">
    <div
      v-for="element in data"
      :key="element.id"
      :class="element.unfolded ? 'make-distinct' : ''"
      class="main-element"
    >
      <div
        class="main-body"
        :class="element.unfolded ? 'element-active' : ''"
        @click="element.unfolded = !element.unfolded"
      >
        <p>{{ element.name }}</p>
        <img
          :class="element.unfolded ? 'transform-up' : ''"
          src="@/icons/down-arrow.png"
          alt=""
        />
      </div>

      <div v-if="element.unfolded" class="unwrapped">
        <div
          v-for="item in element.columns"
          :key="item.name"
          class="unfolded-elements"
        >
          <p>
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style scoped>
.unfolding-table {
  max-height: 400px;
  overflow: auto;
  padding: 0 10px;
}
.main-element {
  display: flex;
  flex-direction: column;
  font-size: 10px;
  border: 1px solid rgba(9, 7, 65, 0.75);
  border-radius: 5px;
  margin: 5px 0;
  width: 300px;
  padding: 0;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  background: #fff;
}
.main-body:hover,
.element-active {
  background: linear-gradient(
    36.47deg,
    rgb(251, 137, 40) 10.51%,
    #e50582 109.44%
  );
  color: #fff;
}
.main-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
}
.main-body p {
  margin-top: 5px;
}
.main-body img {
  width: 15px;
  height: 15px;
  margin-left: 10px;
  cursor: pointer;
  transition: 0.3s all;
}
.transform-up {
  transform: rotate(-180deg);
}
.make-distinct {
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  color: #e2037e;
}
.unwrapped {
  margin-left: 20px;
}
.unfolded-elements {
  border-bottom: 1px solid rgb(208, 213, 225);
  color: rgba(9, 7, 65, 0.75);
}
</style>
